import { useReducer } from "react";
import { GlobalContext } from "./GlobalContext";

const win = window;
let lang = win["lang"];

const env = win.env;
let bmcs = import.meta.env.VITE_PD_BM_CS;

if (env === 'SIT') {
  bmcs = import.meta.env.VITE_SI_BM_CS;
} else if (env === 'PREPROD') {
  bmcs = import.meta.env.VITE_PP_BM_CS;
} else if (env === 'DEV') {
  bmcs = import.meta.env.VITE_DE_BM_CS;
} else if (env === 'SIT2') {
  bmcs = import.meta.env.VITE_SI2_BM_CS
}


const rtl = lang === "ar";
const dir = rtl ? "rtl" : "ltr";
document.documentElement.dir = dir;

const initialState = {
  rtl,
  dir,
  lang,
  loading: false,
  msisdn: '',
  nationalId: '',
  refId: '',
  smsSentTo: '',
  page: 'TR_Login',
  popup: '',
  orderRequestData: {},
  requestLists: [],
  requestDetails: {},
  orderInquiryErrRes: {},
  cancellationFormData: {},
  successType: '',
  bmcs
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_LOADER":
      return {
        ...state,
        loading: action.payload,
      };
    case "SET_MSISDN":
      return {
        ...state,
        msisdn: action.payload.msisdn,
        refId: action.payload.refId,
        smsSentTo: action.payload.smsSentTo,
        nationalId: action.payload.nationalId
      };
    case "UPDATE_PAGE":
      return {
        ...state,
        page: action.payload,
        popup: ''
      };
    case "UPDATE_POPUP":
      return {
        ...state,
        popup: action.payload,
      };
    case "UPDATE_ORDER_REQUEST_DATA":
      return {
        ...state,
        orderRequestData: action.payload,
      };
    case "RESET_DATA":
      return {
        ...initialState,
      }
    case "UPADTE_REQUEST_LISTS":
      return {
        ...state,
        requestLists: action.payload
      }
    case "ORDER_INQUIRY_ERROR_RESPONSE":
      return {
        ...state,
        orderInquiryErrRes: action.payload
      }
    case "UPDATE_REQUEST_DETAILS":
      return {
        ...state,
        requestDetails: action.payload
      }
    case "UPDATE_CANCELLATION_FORM_DATA":
      return {
        ...state,
        cancellationFormData: action.payload
      }
    case "UPDATE_SUCCESS_TYPE":
      return {
        ...state,
        successType: action.payload
      }
    default:
      return state;
  }
};

export const GlobalProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    (<GlobalContext value={{ state, dispatch }}>
      {props.children}
    </GlobalContext>)
  );
};
